export default function (state, payload) {
  const { key } = payload;

  state[key] = payload[key];
}
